import React from 'react'
import styled from 'styled-components'
import FormContent from './FormContent'
import { Link } from 'react-router-dom'

const FormWrapper = () => {
  return (
    <Wrapper>
        <div className="wrapperInnerBox">
            <div className="form-message">
                <h4>Submit Profile</h4>
                <p>Already have an account? <Link to="/login">Verify your profile</Link></p>
                <p className='auth-form-message'><b>Almost there!</b> Build your profile on the AMRS platform. We're excited to welcome you to our shared community and society.</p>
            </div>
            <FormContent />
        </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .wrapperInnerBox{
        width: 80%;
        margin: 1em auto;
       .form-message{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            h4{
                margin: 0;
                font-size: 2rem;
                font-weight: 400;
            }
            p{
                font-size: .9rem;
                padding: 0.4em;
                font-weight: lighter;
                margin: 0.5em;
                a{
                    font-size: 1rem;
                    text-decoration: none;
                    color: var(--primary-color);
                    &:hover{
                        text-decoration: underline;
                    }
                }
            }
            .auth-form-message{
                width: 80%;
                font-size: 0.9rem;
            }
        }
    }

    @media only screen and (min-width: 800px) {
        .wrapperInnerBox{
            width: 50%;
            .form-message{
                h4{
                    font-weight: 500;
                }
                p{
                    font-size: 1.1rem;
                }
            }
        }
    }
  
    @media only screen and (min-width: 1200px) {
        .wrapperInnerBox{
            width: 40%;
            .form-message{
                .auth-form-message{
                    width: 70%;
                }
            }
        }
    } 
`;

export default FormWrapper